<template style="height: 100%;">
  <div class="Consultingadd CommonContentSingle-white">
    <el-form ref="form" style="width: 650px;float: left;border-right: 1px solid #e3e3e3;height: 100%;" :rules="rules" :model="form" label-width="80px">
      <el-form-item v-if="!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))" label="学生" prop="UserID">
        <el-select filterable remote reserve-keyword placeholder="姓名、手机或账号查找"
                   :remote-method="getVsitorNameList" v-model="form.UserID" @change="selectVsitorName()">
          <el-option v-for="item in VsitorNameList" :key="item.UserID" :label="item.UserName+item.UserID" :value="item.UserID"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="咨询师" prop="Consultant">
        <el-select v-model="form.Consultant" placeholder="请选择咨询师">
<!--          <el-option label="全部" value=""></el-option>-->
          <el-option v-for="(item, itemIndex) in CounselorList"  :key="itemIndex" :label="item.RealName" :value="item.UserID"></el-option>
        </el-select>
      </el-form-item>

<!--      <el-form-item label="排班类型" prop="SchedulType">-->
<!--        <el-select v-model="form.SchedulType" placeholder="请选择排班类型">-->
<!--          <el-option label="普通排班" value="0"></el-option>-->
<!--          <el-option label="特殊排班" value="1"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->

<!--      <el-form-item v-if="form.SchedulType == 0" label="排班学年" prop="SchedulYM">-->

<!--        <el-select v-model="form.SchedulYM" clearable placeholder="请选择排班学年">-->
<!--          <el-option v-for="item in dropOptions" :key="item.TermYM" :label="item.Types" :value="item.TermYM">-->
<!--          </el-option>-->
<!--        </el-select>-->

<!--        <el-button type="primary" @click="drawer = true" plain style="margin-left: 20px;">-->
<!--          添加学年-->
<!--        </el-button>-->

<!--      </el-form-item>-->

<!--      <el-form-item v-if="form.SchedulType == 1" label="咨询对象" prop="DepartID">-->
<!--        <el-form-item prop="bumen">-->
<!--          <div class="block">-->
<!--            <el-cascader ref="wcascader" v-model="form.DepartID" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>-->
<!--          </div>-->
<!--        </el-form-item>-->
<!--      </el-form-item>-->

      <el-form-item label="咨询日期" prop="SchedulDate">
        <!--              <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" ></el-date-picker>-->
        <el-date-picker
                v-model="form.SchedulDate"
                align="right"
                type="date"
                placeholder="请选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>

      <!-- <el-select v-model="form.SchedulType" placeholder="请选择排班类型">
        <el-option label="普通排班" value="0"></el-option>
        <el-option label="特殊排班" value="1"></el-option>
      </el-select> -->

      <el-form-item label="咨询地点" prop="ConAddressID">
        <el-select v-model="form.ConAddressID" clearable placeholder="请选择咨询地点">
          <el-option v-for="item in ConAddressitemlist" :key="item.ConAddressID" :label="item.ConAddressName"
            :value="item.ConAddressID + '|' + item.AliasName"></el-option>
        </el-select>
        <el-button type="primary" @click="drawer1 = true" plain style="margin-left: 20px;">
          添加咨询地点
        </el-button>
      </el-form-item>

      <el-form-item label="排班时间" prop="Consulting_time">
        <el-time-picker v-model="form.Consulting_time[0]" value-format="HH:mm" format="HH:mm" placeholder="排班开始时间">
        </el-time-picker>
        至
        <el-time-picker v-model="form.Consulting_time[1]" value-format="HH:mm" format="HH:mm" placeholder="排班结束时间">
        </el-time-picker>

      </el-form-item>

<!--      <el-form-item style="position: relative;" label="咨询方式" prop="ConsultType">-->

<!--        <el-checkbox-group v-model="form.ConsultType">-->
<!--          <el-checkbox label="0" value="0">面对面咨询</el-checkbox>-->
<!--          <el-checkbox label="1" value="1">视频咨询</el-checkbox>-->
<!--        </el-checkbox-group>-->

<!--      </el-form-item>-->

      <el-form-item label="咨询方式" prop="ConsultType">
        <el-select v-model="form.ConsultType" placeholder="请选择咨询方式">
          <el-option label="面对面咨询" value="0"></el-option>
          <el-option label="远程视频" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="save-item">
        <el-button type="success" @click="wswave('form')">保存</el-button>
        <el-button type="warning" @click="gotoSchList">返回</el-button>
      </el-form-item>
    </el-form>

    <el-drawer title="添加咨询地点" :visible.sync="drawer1" :with-header="false">
      <el-form class="drawer_from" ref="ConAddress" :rules="rules" :model="ConAddress" label-width="130px">
        <el-form-item label="咨询机构" prop="DepartID">

          <el-form-item prop="bumen">
            <div class="block">


              <!-- <el-cascader ref="wcascader" v-model="ConAddress.DepartID" @change="bumen" :options="option"
                :props="{ checkStrictly: true }" clearable></el-cascader> -->

              <el-cascader ref="wcascader" v-model="ConAddress.DepartID" @change="Selected_to_shut_dow2"
                @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable
                :placeholder="$t('original.languages3')"></el-cascader>
            </div>
          </el-form-item>
        </el-form-item>

        <el-form-item label="咨询室名称" prop="ConAddressName">
          <el-input maxlength="30" show-word-limit v-model="ConAddress.ConAddressName"></el-input>
        </el-form-item>

        <el-form-item label="校区" prop="campus">
          <el-select v-model="ConAddress.Campus" placeholder="请选择" @change="Campus_switching()">
            <el-option v-for="item in campus_list" :key="item.cDicEnglishValue" :label="item.cDicValue"
              :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="咨询室地址" prop="Address">
          <el-input v-model="ConAddress.Address"></el-input>
        </el-form-item>

        <el-form-item label="咨询室简称" prop="AliasName">
          <el-input v-model="ConAddress.AliasName" maxlength="4"></el-input>
        </el-form-item>

          <el-form-item label="联系人">
            <el-input v-model="ConAddress.ConName"></el-input>
          </el-form-item>
        <el-form-item label="联系电话">
          <el-input maxlength="11" show-word-limit v-model="ConAddress.ConTel"></el-input>
        </el-form-item>



        <el-form-item>
          <el-button type="primary" @click="saveConAddress('ConAddress')">
            立即创建
          </el-button>
          <el-button @click="drawer1 = false;">取消</el-button>
        </el-form-item>

      </el-form>
    </el-drawer>
  </div>
</template>
<script>
var _this;


export default {
  data() {
    var _this = this;
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'));
      } else {
        callback();
      }
    };
    // var validatorSchedulYM = function (rule, value, callback) {
    //   if (value === '') {
    //     callback(new Error('选择学期排班'));
    //   } else {
    //     for (let index = 0; index < _this.dropOptions.length; index++) {
    //       if (_this.dropOptions[index].TermYM == value) {
    //         _this.form.SchedulDate = [
    //           _this.dropOptions[index].StartDate,
    //           _this.dropOptions[index].FinishDate,
    //         ];
    //       }
    //     }
    //     callback();
    //   }
    // };

    return {
      CounselorList:[],
      pdaa: [],
      VsitorNameList:[],
      pickerOptions: '',
      campus_list: [],
      data: [],
      xhaoxhax: false,
      drawer: false,
      drawer1: false,
      dropOptions: [],
      dropUserAll: [],
      props: { multiple: true, expandTrigger: 'hover' },
      ConAddressitemlist: [], //咨询地点下拉框列表
      option: [],
      pIdx: '',
      Idx: '',
      wdialogVisible: false,
      wConsulting_time: ['', ''],
      // [
      //   new Date(),
      //   new Date(new Date().getTime() + 1 * 60 * 60 * 1000),
      // ],
      options: [],
      selDate:'',
      formTermDeploy: {
        StartYear: '', //学年开始
        EndYear: '', //学年结束
        StartDate: '', // 开始时间
        FinishDate: '', // 学期结束时间
        Termtime: '',
      },

      form: {
        UserID:(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))?this.Global.userID:'',
        Consultant: '', //咨询师编号
        // SchedulYM: '', //学期ID
        ConAddressID: '', //咨询地址ID
        ConsultType: "", //咨询方式
        // SchedulType: '0', //发布类型
        // DepartID: '', //机构地址
        SchedulDate: '', //排班日期
        Consulting_time: ['', ''],
        TimeRange: '',

      },
      ConAddress: {
        //咨询师地点
        DepartID: '',
        ConAddressName: '',
        Address: '',
        ConTel: '',
        ConName: '',
        AliasName: '',
      },
      rules: {
        UserID: [
          { required: true, message: '请输入并选择学生', trigger: 'change' },
        ],
        Consultant: [
          { required: true, message: '请选择咨询师', trigger: 'change' },
        ],
        ConsultType: [
          { required: true, message: '请选择咨询方式', trigger: 'change' },
        ],
        // SchedulYM: [
        //   { required: true, validator: validatorSchedulYM, trigger: 'change' },
        // ],
        Consulting_institutions: [
          { required: true, message: '请选择咨询方式', trigger: 'change' },
        ],
        // SchedulType: [
        //   { required: true, message: '请选择排班类型', trigger: 'change' },
        // ],
        SchedulDate: [
          { required: true, message: '请选择排班日期', trigger: 'change' },
        ],
        ConAddressID: [
          { required: true, message: '请选择咨询地点', trigger: 'change' },
        ],
        Consulting_time: [
          { required: true, message: '请选择排班时间', trigger: 'change' },
        ],
        ConTel: [
          { required: true, validator: validatorPhone, trigger: 'blur' },
        ],
        ConName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        Address: [
          { required: true, message: '请输入咨询地址', trigger: 'blur' },
        ],
        ConAddressName: [
          { required: true, message: '请输入咨询室名称', trigger: 'blur' },
        ],
        AliasName: [
          { required: true, message: '请输入咨询室简称', trigger: 'blur' },
        ],
        DepartID: [
          { required: true, message: '请选择咨询机构', trigger: 'blur' },
        ],
      },
    };
  },
  components: {},
  watch: {
    // 被侦听的变量count
    // 'form.SchedulType'() {
    //   this.form.SchedulDate = ''
    // }
  },
  methods: {
    getVsitorNameList(keyword) {
      if (keyword !== '') {
        this.$Http_Post('ConsultSubscribe/GetStudentList', {
          Keyword: keyword,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    async selectVsitorName() {
      // for (let index = 0; index < this.VsitorNameList.length; index++) {
      //   if (this.VsitorNameList[index].UserID == this.form.UserID) {
      //     this.form.UserID = this.VsitorNameList[index].UserID;
      //     this.submitConsult.UserID = this.VsitorNameList[index].UserID;
      //   }
      // }
      this.submitConsult.UserID = this.form.UserID;
      this.GetConsultTotal(this.form.UserID)
      // setTimeout(()=> {
      this.getSchedul();// 需要执行的代码
      // }, 500);
    },
    selectTime() {
      this.pickerOptions = {
        disabledDate : (time) => time.getTime() < Date.now() - 3600 * 1000 * 24,
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '后天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
            picker.$emit('pick', date);
          }
        }]
      }
    },
    async getSchedul(){
      if(this.form.UserID=='' && !(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))) {
        this.Global.request_failure("必须选择学生，才能预约！");
      }else if(!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075)) || (this.BasicInfo.BasicAnswerStatus == 1 && this.ConsultInfo.ConsultAnswerStatus == 1 && this.ConsultInfo.SASResult != '' && this.ConsultInfo.SDSResult != '')) {
        if(this.selDate != ""){
          this.form.ScheduleDate = this.Global.formatDate(this.selDate,"YYYY-MM-DD");
        }
        // const res = await this.$Http_Post('ConsultAppoint/GetSchedulListAPP',this.form);
        // if (res.Code == 0) {
        //   this.DayInfo = [];
        //   this.radio3 = 0;
        //   this.DayInfo = res.Data.DayInfo;
        // }
      }
      // if (this.RoleID == 1058){
      //   this.form.UserID == this.Global.userID;
      //   console.warn(this.form);
      //   console.warn(this.Global.userID);
      // }else {
      //   this.form.AppointmentID = "0";
      //   this.form.SASResult = "0";
      //   this.form.SDSResult = "0";
      // }
    },
    drop() {
      this.$Http_Post('ConsultSubscribe/ShowTermDeploy', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dropOptions = res.Data;
        }
      });
    },
    dropGetUserAll() {
      this.$Http_Post('ConsultSubscribe/GetUserAll', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dropUserAll = res.Data;
        }
      });
    },
    dropConAddress() {
      //咨询地点下拉框
      this.$Http_Post('ConsultSubscribe/GetConAddress', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ConAddressitemlist = res.Data;
        }
      });
    },
    saveConAddress(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('ConsultSubscribe/AddConAddress', {
            DepartID: this.ConAddress.DepartID,
            ConAddressName: this.ConAddress.ConAddressName,
            Address: this.ConAddress.Address,
            ConTel: this.ConAddress.ConTel,
            ConName: this.ConAddress.ConName,
            Campus: this.ConAddress.Campus,
            AliasName: this.ConAddress.AliasName
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.drop();
              (this.drawer = false),
                this.$message({
                  type: 'success',
                  message: '添加成功',
                });
              this.drawer1 = false;
              this.dropConAddress();
            } else {
              this.$message({
                type: 'success',
                message: res.Message,
              });
            }
            this.$refs[formName].resetFields();
          });
        } else {
          return false;
        }
      });
    },

    saveTerm() {
      let message = '';
      if (
        this.formTermDeploy.StartYear == '' ||
        this.formTermDeploy.EndYear == ''
      ) {
        message = '请选择学年';
      } else if (
        this.formTermDeploy.StartDate == '' ||
        this.formTermDeploy.FinishDate == ''
      ) {
        message = '请选择学年时间';
      } else message = '';
      if (message == '') {
        this.$Http_Post(
          'ConsultSubscribe/AddTermDeploy',
          this.formTermDeploy
        ).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.drop();
            this.drawer = false;
            (this.formTermDeploy = {
              StartYear: '', //学年开始
              EndYear: '', //学年结束
              StartDate: '', // 开始时间
              FinishDate: '', // 学期结束时间
              Termtime: '',
            }),
              this.Global.request_successful('添加成功');
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      } else this.Global.request_info(message);
    },
    wswave(formName) {
      if (this.form.ConsultType == "") {
        this.Global.request_failure('请选择咨询方式');
        return false
      } else if (this.form.ConAddressID == '') {
        this.Global.request_failure('请选择咨询地点');
      }else if (this.form.SchedulDate == '') {
        this.Global.request_failure('请选择咨询日期');
      }else if (this.form.Consultant == '') {
        this.Global.request_failure('请选择咨询师');
      }else if (this.form.UserID == '') {
        this.Global.request_failure('请输入并选择学生');
      }else if (!((Number(this.form.Consulting_time[1].slice(0, 2))) - Number(this.form.Consulting_time[0].slice(0, 2)) >= 1 && (Number(this.form.Consulting_time[1].slice(3, 5))) == Number(this.form.Consulting_time[0].slice(3, 5)))) {//判断是否为整点
        // let num = Number(this.form.Consulting_time[1].slice(0, 2)) - Number(this.form.Consulting_time[0].slice(0, 2));//间隔几个小时
        this.Global.request_failure('时间间隔只能为一个小时！');
      }else {
        this.$Http_Post('ConsultSubscribe/AddFastSchedul', {
          UserID: this.form.UserID,
          Consultant: this.form.Consultant, //咨询师数组
          // SchedulYM: this.form.Consulting_semester,
          ConAddressKey: this.form.ConAddressID.split('|')[0],
          // SchedulYM: this.form.SchedulYM,
          ConsultType: this.form.ConsultType,
          // DeputID: this.form.DepartID,
          SchedulDate: this.form.SchedulDate,
          TimeRange:this.form.Consulting_time.join("-"),
          // weeksdata: this.weeksdata,
          // SchedulType: this.form.SchedulType,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.drop();
            (this.drawer = false),
                    this.$message({
                      type: 'success',
                      message: '添加成功',
                    });
            this.$router.push('/CounselorLeave/Consultation_appointment');
          } else {
            this.$message({
              type: 'warning',
              message: res.Message,
            });
          }
        });
      }
    },

    Selected_to_shut_dow(dt) {
      this.form.DepartID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    Selected_to_shut_dow2(dt) {
      this.ConAddress.DepartID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {
      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      } else {

      }
    },


    checkTime1(start, end, start2, end2) {
      if (start == '-|') {
        return true;
      } else {

        if (Number(start2) > Number(start)) {
          return true;
        } else {
          return false;
        }


        // if (Number(start2) >= Number(end2)) {
        //   return false;
        // }
        // if (Number(end2) <= Number(start) || Number(start2) >= Number(end)) {
        //   return true;
        // } else {
        //   return false;
        // }
      }
      
    },

    fuzzy(val) { },
    csvv(a, b, c) { },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => { });
    },
    xiugaiqued() {//修改时间事件
      if (((Number(this.wConsulting_time[1].slice(0, 2))) - Number(this.wConsulting_time[0].slice(0, 2)) >= 1) && ((Number(this.wConsulting_time[1].slice(3, 5))) == Number(this.wConsulting_time[0].slice(3, 5)))) {
        // this.wdialogVisible = false;
        // let timestr = this.wConsulting_time[0] + '-' + this.wConsulting_time[1] + '|' + this.pdaa; //合并后时间段
        // this.weeksdata[this.pIdx].weeks[this.Idx] = timestr;
        // this.$forceUpdate();
      } else {
        this.Global.request_failure('时间段只能为一个小时');
      }
    },
    gotoSchList() {
      this.$router.push('/CounselorLeave/Consultation_appointment');
    },
  },
  mounted() {
    _this = this;
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.data2 = res.Data;
      }
    })
    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
        this.ConAddress.Campus = res.Data[0].dicKey;
      }
    })

    this.$Http_Post('/ConsultAppoint/GetCounselorInfoList',{pageIndex:0,pageSize:999}).then((res) => {
      if (res.Code == 0) {
        this.CounselorList = res.Data;
        this.Days = res.Data.Days;
      }
    });

    // this.$Http_Post('ConsultAppoint/GetScheduleParams').then((res) => {
    //   if (res.Code == 0) {
    //     this.CounselorList = res.Data.CounselorList;
    //     this.Days = res.Data.Days;

    //     // console.warn(this.Days)
    //   }
    // });
    this.drop();
    this.dropConAddress();
    this.dropGetUserAll();
    this.selectTime();
  },
};
</script>
<style>
.Consultingadd{min-width: 2000px !important;}
.Consultingadd .vax{}
.Consultingadd .vax >li {
  float: left;
  width: 160px;
  text-align: center;
}
.Consultingadd .vax ul{
  border: 1px solid rgb(227, 227, 227);
  height: 40px;line-height: 40px;
  margin-top: -1px;
  margin-left: -1px;
}
.Consultingadd .bfv:hover {
  background-color: coral;
}

.Consultingadd .bfv {
  height: 22px;
  text-align: center;
  position: relative;
  border-radius: 3px;
}

.Consultingadd .bfv:hover .udiv {
  display: block;
  background-color: rgb(240, 102, 10);
  margin-left: -5px;
}

.Consultingadd .udiv {
  position: absolute;
  top: 0px;
  left: 6px;
  height: 40px;
  width: 100%;
  display: none;
  color: white;
}

.Consultingadd .udiv .option {
  padding: 2px;
  background-color: rgb(240, 102, 10);
  border-radius: 3px;
  font-size: 10px;
  cursor: pointer;
}

.wyu .el-range-editor.el-input__inner {
  width: 95%;
}

.drawer_from {
  width: 90%;
  margin: 100px 0px auto;
}
</style>
